import { render, staticRenderFns } from "./ToolVersionsButton.vue?vue&type=template&id=0b66f3f8&"
import script from "./ToolVersionsButton.vue?vue&type=script&setup=true&lang=js&"
export * from "./ToolVersionsButton.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports